/**
 * The two independently-scheduled backup jobs (`BackupKind`, `design/05-backup-engine.md` §5.0) —
 * there is no combined endpoint, so triggering "a backup" always means two `jobTriggerBackup`
 * calls, one per kind, each with its own `Idempotency-Key`. Shared by `VBackup.tsx`'s on-demand
 * "Back up now" and `ObWz6.tsx`'s "Start my first backup" (2026-09-25) so the two never drift into
 * triggering different things under the same idea — see `ObWz6.tsx`'s own doc comment for why the
 * onboarding screen needs this at all rather than the endpoint meant to launch its own job.
 */
import { getApiClient, unwrap, type Problem } from '@/data/apiClient'
import type { components } from '@/api/generated/schema'

type JobRef = components['schemas']['JobRef']
type BackupKind = components['schemas']['BackupKind']

export const BOTH_BACKUP_KINDS: readonly BackupKind[] = ['DATA_BACKUP', 'CONFIG_BACKUP']

export async function triggerBothBackups(orgId: string, workspaceId: string, tag?: string): Promise<readonly JobRef[]> {
  const client = getApiClient()
  const responses = await Promise.all(
    BOTH_BACKUP_KINDS.map((kind) =>
      client.POST('/orgs/{org_id}/workspaces/{workspace_id}/backups', {
        params: { path: { org_id: orgId, workspace_id: workspaceId } },
        body: { backup_kind: kind, tag: tag || undefined },
        headers: { 'Idempotency-Key': crypto.randomUUID() },
      }),
    ),
  )
  return responses.map((response) => unwrap(response as { data?: JobRef; error?: Problem }))
}
